import { render } from "./FbAuthenticationHanlder.vue?vue&type=template&id=349548dc&scoped=true"
import script from "./FbAuthenticationHanlder.vue?vue&type=script&lang=js"
export * from "./FbAuthenticationHanlder.vue?vue&type=script&lang=js"

import "./FbAuthenticationHanlder.vue?vue&type=style&index=0&id=349548dc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-349548dc"

export default script